// Budget and financial planning components
import { defineAsyncComponent } from 'vue'

export default {
  BudgetEditAll: defineAsyncComponent(() => import('../budget_edit_all.vue')),
  BudgetForecastsIndex: defineAsyncComponent(
    () => import('../admin/budget_forecasts/index.vue')
  ),
  BudgetProfileTable: defineAsyncComponent(
    () => import('../budget_profile_table.vue')
  ),
  CreateBudgetForecastsDialog: defineAsyncComponent(
    () => import('../create_budget_forecasts_dialog.vue')
  ),
  PriceProfileTable: defineAsyncComponent(
    () => import('../price_profile_table.vue')
  ),
  RevenueProfileTable: defineAsyncComponent(
    () => import('../revenue_profile_table.vue')
  )
}
